import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

type Props = {
    headingKey: string;
    descriptionKey?: string;
};

export const WizardStepHeading = ({ headingKey, descriptionKey }: Props) => {
    const { translate } = useTranslate();

    return (
        <Stack gap="4px">
            <Text
                fontVariant="h5_2"
                color={colorsPalettes.carbon["500"]}
            >
                {translate(headingKey)}
            </Text>
            {descriptionKey ? (
                <Text
                    fontVariant="body1"
                    color={colorsPalettes.carbon["300"]}
                >
                    {translate(descriptionKey)}
                </Text>
            ) : null}
        </Stack>
    );
};
